export default __webpack_public_path__ + "static/media/bannerImage.9f75bb3f.png";